import React, { useContext } from 'react';
import './actionResult.scss';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import PropTypes from 'prop-types';
import { useGetFaqContentQuery } from '../../data/kontentAi';
import { FeatureFlagContext } from '../../contextProviders/featureFlagContext';
import { BrandContext } from '../../contextProviders/brandContext';
import { FaqsBlock } from '../helpCentre/faqsBlock/faqsBlock';

export const ActionResult = ({
  title,
  descriptionTitle,
  description,
  showIcon,
  hasFaqContent = false,
  faqCodename,
  handleActionRedirection,
  buttonText = 'Back to Dashboard'
}) => {
  const { activeBrandContext } = useContext(BrandContext);
  const { cspConfiguration } = useContext(FeatureFlagContext);
  const isKontentAiPreviewEnabled = cspConfiguration?.IsKontentAIPreviewEnabled || false;

  const { data: faqsData } = useGetFaqContentQuery(
    {
      brandPartner: activeBrandContext.brand.key,
      faqCodeName: faqCodename,
      previewEnabled: isKontentAiPreviewEnabled
    },
    { skip: !hasFaqContent || !faqCodename }
  );
  const hasFaqData = faqsData && Object.keys(faqsData).length > 0;
  return (
    <div className="action-result">
      <div className="main-content">
        {title && <h2>{title}</h2>}

        {showIcon && (
          <div className="petIcons">
            <Icon icon="paw" />
          </div>
        )}
        {descriptionTitle && <h3>{descriptionTitle}</h3>}
        {description && <span className="description">{description}</span>}

        <div className="button-container">
          <button
            type="button"
            id="goToDashboardButton"
            className="button primary"
            onClick={handleActionRedirection}
          >
            <span className="labelText">{buttonText}</span>
          </button>
        </div>
      </div>
      {hasFaqData && (
        <aside>
          <FaqsBlock
            questionSet={faqsData?.FAQs?.questions}
            heading={{ text: 'FAQs' }}
          />
        </aside>
      )}
    </div>
  );
};

ActionResult.propTypes = {
  title: PropTypes.string,
  descriptionTitle: PropTypes.string,
  description: PropTypes.string,
  showIcon: PropTypes.bool,
  hasFaqContent: PropTypes.bool,
  faqCodename: PropTypes.string,
  handleActionRedirection: PropTypes.func.isRequired,
  buttonText: PropTypes.string
};
